<template>
  <div>
    <b-modal id="modalEditPromisedPaymentSetting" ref="modalEditPromisedPaymentSetting"
      :title="$t('Promised payment setting')" hide-footer>
      <div  v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.id != 0" disabled label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :disabled="editItem.id != 0" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.group_id" :options="groups" :disabled="editItem.id != 0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Active')" label-cols="4" label-cols-xl="4" label-cols-md="4">
           <b-form-checkbox switch size="lg" v-model="editItem.is_enabled" value="1" unchecked-value="0" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Max payment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.max_value" :disabled="editItem.flags == 1" />
              <b-form-checkbox switch v-model="editItem.flags" value="1" unchecked-value="0" /> {{ this.$t('Until balance not positive') }}
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Expires in (days)')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.max_duration" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Interval between uses (days)')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.interval_duration" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Min balance')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.min_balance" :disabled="editItem.use_min_balance == 0" />
          <b-form-checkbox switch v-model="editItem.use_min_balance" value="1" unchecked-value="0" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Service')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select  v-model="editItem.service_id" :options="onceServices" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Free if balance over')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.free_balance" :disabled="editItem.use_free_balance == 0" />
          <b-form-checkbox switch v-model="editItem.use_free_balance" value="1" unchecked-value="0" />
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditPromisedPaymentSetting')" size="md"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tmpElementId: -1
    }
  },
  props: {
    editItem: null
  },
  methods: {
    save () {
      if (this.editItem.group_id === -1) {
        this.$root.$emit('makeToasts', 'warning', 'Please fill field group', 'Warning')
        return
      }
      this.editItem.max_duration *= 86400
      this.editItem.interval_duration *= 86400
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_PROMISED_PAYMENTS_SETTINGS', this.editItem)
        : this.$store.dispatch('Settings/CREATE_PROMISED_PAYMENTS_SETTINGS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, this.$t('Error'))
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_PROMISED_PAYMENTS_SETTINGS')
          this.$refs.modalEditPromisedPaymentSetting.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  computed: {
    onceServices () {
      let res = []
      for (let el of this.$store.getters['Tariffing/SERVICES']) {
        if (el.service_type !== 1) {
          continue
        }
        let newEl = {}
        newEl.value = el.service_id
        newEl.text = el.service_name
        res.push(newEl)
      }
      res.push({value: 0, text: this.$t('No')})
      return res
    },
    groups () {
      let res = []
      for (let el of this.$store.getters['Users/GROUPS']) {
        if (this.editItem.id === 0) {
          let isAlreadyHas = false
          for (let elPS of this.promisedPayments) {
            if (elPS.group_id === el.group_id) {
              isAlreadyHas = true
              break
            }
          }
          if (isAlreadyHas) {
            continue
          }
        }
        let newEl = {}
        newEl.value = el.group_id
        newEl.text = el.group_name
        res.push(newEl)
      }
      if (this.editItem.id === 0) {
        let isAlreadyHas = false
        for (let elPS of this.promisedPayments) {
          if (elPS.group_id === 0) {
            isAlreadyHas = true
            break
          }
        }
        if (!isAlreadyHas) {
          res.push({value: 0, text: this.$t('All')})
        }
      } else {
        res.push({value: 0, text: this.$t('All')})
      }
      return res
    },
    promisedPayments () {
      return this.$store.getters['Settings/PROMISED_PAYMENTS_SETTINGS']
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_SERVICES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/promisedPayments/editModal.vue